export const RENTER_START_TOURING_OPTION_TODAY = 'Today';
const RENTER_START_TOURING_OPTION_THIS_WEEK = 'This week';
const RENTER_START_TOURING_OPTION_WITHIN_A_MONTH = 'Within a month';
const RENTER_START_TOURING_OPTION_NEXT_FEW_MONTHS = 'Next few months';
const RENTER_START_TOURING_OPTION_JUST_BROWSING = "I'm just browsing";

const startTouringOptionItems = [
  {
    label: 'Today',
    value: RENTER_START_TOURING_OPTION_TODAY,
  },
  {
    label: 'This week',
    value: RENTER_START_TOURING_OPTION_THIS_WEEK,
  },
  {
    label: 'Within a month',
    value: RENTER_START_TOURING_OPTION_WITHIN_A_MONTH,
  },
  {
    label: 'Next few months',
    value: RENTER_START_TOURING_OPTION_NEXT_FEW_MONTHS,
  },
  {
    label: "I'm just browsing",
    value: RENTER_START_TOURING_OPTION_JUST_BROWSING,
  },
];

export default startTouringOptionItems;
